(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["hi-lab-ui-overlays"] && !Shopify.designMode) return;
  try {
    (() => {
    const root = document.documentElement;
    const scrollPosition = () => Math.max(0, Math.min(window.scrollY, Math.max(0, root.scrollHeight - window.innerHeight)));
    let previousY = scrollPosition();
    let direction = 0;
    let distance = 0;
    let scheduled = false;

    const updateScroll = () => {
      scheduled = false;
      const currentY = scrollPosition();
      const delta = currentY - previousY;
      previousY = currentY;

      if (currentY <= 16) {
        direction = 0;
        distance = 0;
        root.classList.remove('hi-lab-scrolling-down');
        return;
      }
      if (delta === 0) return;

      const nextDirection = Math.sign(delta);
      distance = nextDirection === direction ? distance + Math.abs(delta) : Math.abs(delta);
      direction = nextDirection;
      if (distance >= 12) {
        root.classList.toggle('hi-lab-scrolling-down', direction > 0);
        distance = 0;
      }
    };

    window.addEventListener('scroll', () => {
      if (!scheduled) {
        scheduled = true;
        window.requestAnimationFrame(updateScroll);
      }
    }, { passive: true });
    window.addEventListener('resize', () => {
      previousY = scrollPosition();
      direction = 0;
      distance = 0;
    });

    if (!('IntersectionObserver' in window)) return;

    const targets = new Map();
    const update = () => {
      root.classList.toggle('hi-lab-controls-visible', [...targets.values()].some(Boolean));
    };
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (targets.has(entry.target)) targets.set(entry.target, entry.isIntersecting);
      });
      update();
    }, { rootMargin: '16px' });

    const refresh = () => {
      targets.forEach((visible, element) => {
        if (!element.isConnected) {
          observer.unobserve(element);
          targets.delete(element);
        }
      });
      document.querySelectorAll('.product-info__block-item[data-block-type="buy-buttons"], .footer__newsletter-form').forEach((element) => {
        if (!targets.has(element)) {
          targets.set(element, true);
          observer.observe(element);
        }
      });
      update();
    };

    refresh();
    ['shopify:section:load', 'shopify:section:unload', 'product:rerender'].forEach((eventName) => {
      document.addEventListener(eventName, () => queueMicrotask(refresh));
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
